/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment-timezone'
import React, { useEffect, useImperativeHandle, useState } from 'react'

import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import {
    exportCurrentMandatoryBarrier,
    getCurrentMandatoryBarrierEvent
} from 'plugin-codaf-risk-ext-bowtie/services/reportEvents'
import { IBarrierStatusSpecialStatus } from 'plugin-codaf-risk-ext-bowtie/types'
import { OrderFields } from 'plugin-codaf-risk-ext-bowtie/types/enums'
import { IMandatoryBarriersReport } from 'plugin-codaf-risk-ext-bowtie/types/reports'

import { NoData, NoInfo } from '../../styles'
import { ReportPopover } from '../ReportFilter/ReportPopover'

interface IProps {
    setItemsLength: (k: number) => void
    start: number
    numberOfItems: number
    time: string | null
    startDay: string | null
    endDay: string | null
    startHour: string | null
    endHour: string | null
    setExportLoading: (k: boolean) => void
    page: number
    setPage: (k: number) => void
}

interface IOrder {
    field: string
    order: boolean
}

export const MandatoryBarriers = React.forwardRef<any, IProps>(function MandatoryBarriers(
    { setItemsLength, numberOfItems, startDay, startHour, endDay, endHour, page, setPage, setExportLoading },

    ref
) {
    const [isLoading, setIsLoading] = useState(false)
    const [events, setEvents] = useState<IMandatoryBarriersReport>()

    const [order, setOrder] = useState<IOrder>({ field: OrderFields.DATE, order: true })

    const [searchResource, setSearchResource] = useState<string>('')
    const [listResource, setListResource] = useState(new Set<string>())
    const [filterResource, setFilterResource] = useState(new Set<string>())

    const [searchBowtieCode, setSearchBowtieCode] = useState<string>('')
    const [listBowtieCode, setListBowtieCode] = useState(new Set<string>())
    const [filterBowtieCode, setFilterBowtieCode] = useState(new Set<string>())

    const [searchBarrierId, setSearchBarrierId] = useState<string>('')
    const [listBarrierId, setListBarrierId] = useState(new Set<string>())
    const [filterBarrierId, setFilterBarrierId] = useState(new Set<string>())

    const [searchBarrierName, setSearchBarrierName] = useState<string>('')
    const [listBarrierName, setListBarrierName] = useState(new Set<string>())
    const [filterBarrierName, setFilterBarrierName] = useState(new Set<string>())

    const [searchSafetyCritical, setSearchSafetyCritical] = useState<string>('')
    const [listSafetyCritical, setListSafetyCritical] = useState(new Set<string>())
    const [filterSafetyCritical, setFilterSafetyCritical] = useState(new Set<string>())

    const [searchResponsible, setSearchResponsible] = useState<string>('')
    const [listResponsible, setListResponsible] = useState(new Set<string>())
    const [filterResponsible, setFilterResponsible] = useState(new Set<string>())

    const [update, setUpdate] = useState<number>()

    const renderTableRow = (): JSX.Element[] => {
        if (events?.reportEvent) {
            const renderObject = events?.reportEvent.map((item, index) => {
                return (
                    <tr key={index} className={`resource-barrier-status ${index === 0 ? 'first-margin' : ''}`}>
                        <td valign="middle" className={'common-width'}>
                            {item.resource}
                        </td>
                        <td valign="middle" className={'common-width'}>
                            {item.bowtieCode}
                        </td>
                        <td valign="middle" className={'common-width'}>
                            {item.barrierId}
                        </td>
                        <td valign="middle" className={'common-width'}>
                            {item.barrierName}
                        </td>
                        <td valign="middle" className={'common-width'}>
                            <span className="SafetyCritical">{item.safetyCritical}</span>
                        </td>
                        <td valign="middle" className={'common-width'}>
                            <span>{item.responsible}</span>
                        </td>
                    </tr>
                )
            })

            return renderObject
        }
    }

    const dateFormatToRequisition = (dateToConvert): string => {
        const initialDateToRequisition = new Date(dateToConvert)
        const formatedInitialDate = moment(initialDateToRequisition).format('YYYY-MM-DD')

        return formatedInitialDate
    }

    const formatSetToArray = (setToFormat: Set<string>): string[] => {
        const arr = []
        setToFormat.forEach(item => {
            arr.push(item)
        })

        return arr
    }

    const getEvents = async (): Promise<void> => {
        try {
            setIsLoading(true)
            const barrierEvents = await getCurrentMandatoryBarrierEvent({
                startDay: dateFormatToRequisition(startDay),
                startHour: startHour,
                endDay: dateFormatToRequisition(endDay),
                endHour: endHour,
                page: page,
                perPage: numberOfItems,
                sortBy: order.field,
                sortOrder: order.order ? 'ASC' : 'DESC',
                filterByResource: formatSetToArray(filterResource),
                filterByBowtieCode: formatSetToArray(filterBowtieCode),
                filterByBarrierId: formatSetToArray(filterBarrierId),
                filterByBarrierName: formatSetToArray(filterBarrierName),
                filterBySafetyCritical: formatSetToArray(filterSafetyCritical),
                filterByResponsible: formatSetToArray(filterResponsible)
            })
            setEvents(barrierEvents)
            setItemsLength(barrierEvents.total)
        } catch (err) {
            globalNotification.error(err.message ?? i18n('An error occurred on list events.'))
        } finally {
            setIsLoading(false)
        }
    }

    const onClearAllFilters = (): void => {
        setUpdate(update + 1)
        globalNotification.success(i18n('Filters removed successfully.'))
    }

    useImperativeHandle(ref, () => ({
        async exportCurrentMandatoryBarrier() {
            try {
                setExportLoading(true)
                await exportCurrentMandatoryBarrier({
                    startDay: dateFormatToRequisition(startDay),
                    startHour: startHour,
                    endDay: dateFormatToRequisition(endDay),
                    endHour: endHour,

                    sortBy: order.field,
                    sortOrder: order.order ? 'ASC' : 'DESC',
                    filterByResource: formatSetToArray(filterResource),
                    filterByBowtieCode: formatSetToArray(filterBowtieCode),
                    filterByBarrierId: formatSetToArray(filterBarrierId),
                    filterByBarrierName: formatSetToArray(filterBarrierName),
                    filterBySafetyCritical: formatSetToArray(filterSafetyCritical),
                    filterByResponsible: formatSetToArray(filterResponsible)
                })
                globalNotification.success(i18n('Report exported successfully.'))
            } catch (error) {
                globalNotification.error(i18n('Error on exporting report.'))
            } finally {
                setExportLoading(false)
            }
        }
    }))

    useEffect(() => {
        getEvents()
    }, [startDay, startHour, endDay, endHour, page, order, filterResource, filterBowtieCode, filterBarrierId, filterBarrierName, filterSafetyCritical, filterResponsible])

    useEffect(() => {
        setPage(1)
    }, [order, filterResource, filterBowtieCode, filterBarrierId, filterBarrierName, filterSafetyCritical, filterResponsible])

    return (
        <>
            <button className="clearAllFilters" onClick={() => onClearAllFilters()}>
                {i18n('Clear all filter view')}
                <i className="far fa-filter"></i>
            </button>
            <div className="tableContainer customScroll">
                <table>
                    <thead className="tableHeader">
                        <tr className={'resource-barrier-status-header'}>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchResource}
                                    setSearch={setSearchResource}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.RESOURCE}
                                    list={listResource}
                                    setList={setListResource}
                                    filter={filterResource}
                                    setFilter={setFilterResource}
                                    onClearAll={update}
                                    buttonTitle={'resource'}
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchBowtieCode}
                                    setSearch={setSearchBowtieCode}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.BOWTIECODE}
                                    list={listBowtieCode}
                                    setList={setListBowtieCode}
                                    filter={filterBowtieCode}
                                    setFilter={setFilterBowtieCode}
                                    onClearAll={update}
                                    buttonTitle="bowtie code"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchBarrierId}
                                    setSearch={setSearchBarrierId}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.BARRIER_ID}
                                    list={listBarrierId}
                                    setList={setListBarrierId}
                                    filter={filterBarrierId}
                                    setFilter={setFilterBarrierId}
                                    onClearAll={update}
                                    buttonTitle="barrier id"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchBarrierName}
                                    setSearch={setSearchBarrierName}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.BARRIER_NAME}
                                    list={listBarrierName}
                                    setList={setListBarrierName}
                                    filter={filterBarrierName}
                                    setFilter={setFilterBarrierName}
                                    onClearAll={update}
                                    buttonTitle="barrier name"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchSafetyCritical}
                                    setSearch={setSearchSafetyCritical}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.SAFETY_CRITICAL}
                                    list={listSafetyCritical}
                                    setList={setListSafetyCritical}
                                    filter={filterSafetyCritical}
                                    setFilter={setFilterSafetyCritical}
                                    onClearAll={update}
                                    buttonTitle="Safety Critical"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchResponsible}
                                    setSearch={setSearchResponsible}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.RESPONSIBLE}
                                    list={listResponsible}
                                    setList={setListResponsible}
                                    filter={filterResponsible}
                                    setFilter={setFilterResponsible}
                                    onClearAll={update}
                                    buttonTitle="Responsible name"
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <NoInfo>
                                <i className="fa fa-spinner fa-spin" />
                            </NoInfo>
                        ) : events?.total === 0 ? (
                            <NoData>{i18n('There is no data for the specified period.')}</NoData>
                        ) : (
                            renderTableRow()
                        )}
                    </tbody>
                </table>
            </div>
        </>
    )
})
